import React from 'react'
import Layout from '../Layout/Layout'
import Form from '../components/ContactForm/Form';


function faq()  {
    return (
        <div>
        <Layout>
            <Form />
        </Layout>
        </div>
    )
}
export default faq;